import { modalCreate, renderModalShadow, showHybridCardCreate } from '@subaio/components'

export const { ModalProvider, useModal } = modalCreate({
	types: {
		showCard: showHybridCardCreate(({ theme }) => ({
			backgroundColor: theme.color.textContrast,
			textColor: theme.color.text,
			mobileMediaQueryName: 'isMobile',
		})),
	},
	renderShadow: renderModalShadow,
})
